import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SelectFunds from "../views/SelectFunds.vue";
import Portfolio from "../views/Portfolio.vue";
import PortfolioFunded from "../views/PortfolioFunded.vue";
import PickFive from "../views/PickFive.vue";
import StratReview from "../views/StratReview.vue";
import UnfundedReview from "../views/UnfundedReview.vue";
import FundedReview from "../views/FundedReview.vue";
import BestFiveReview from "../views/BestFiveReview.vue";
import Admin from "../views/Admin.vue";
import AdminGameController from "../views/AdminGameController.vue";
import games from "../views/games.vue";
import playOptions from "../views/playOptions.vue";


import firebase from "@/main.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin
  },
  {
    path: "/games",
    name: "games",
    component: games
  },
  {
    path: "/admingamecontroller",
    name: "AdminGameController",
    component: AdminGameController,
    meta: {
      admin: true
    }
  },
  {
    path: "/selectfunds",
    name: "SelectFunds",
    component: SelectFunds,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/playoptions",
    name: "playOptions",
    component: playOptions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/stratreview",
    name: "StratReview",
    component: StratReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/unfundedreview",
    name: "UnfundedReview",
    component: UnfundedReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/fundedreview",
    name: "FundedReview",
    component: FundedReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/bestfivereview",
    name: "BetFiveReview",
    component: BestFiveReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    component: Portfolio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/portfoliofunded",
    name: "PortfolioFunded",
    component: PortfolioFunded,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/pickfive",
    name: "PickFive",
    component: PickFive,
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "*",
    name: "Home",
    component: Home
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const admin = to.matched.some(record => record.meta.admin);
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next("signin");
  } else if (admin && !(await firebase.getAdmin())) {
    next("admin");
  } else {
    next();
  }
});

export default router;
